// import { Helmet } from 'react-helmet-async'&#10;import AboutBanner from '@/components/ui/AboutPage/AboutBanner'&#10;import AboutSection from '@/components/ui/AboutPage/AboutSection'&#10;import OurTeam from '@/components/ui/AboutPage/OurTeam'&#10;import InstagramGrid from '@/components/ui/Homepage/InstagramFeed'&#10;import React from 'react'&#10;&#10;const About = () => {&#10;  return (&#10;    <>&#10;      <Helmet>&#10;        <title>About Bakelore - Best Bakery in Hyderabad | Madhapur</title>&#10;        <meta name="description" content="Learn about Bakelore, Hyderabad's premier bakery in Madhapur. Our story, team, and passion for perfect cakes and desserts." />&#10;        <meta property="og:title" content="About Bakelore - #1 Bakery in Hyderabad" />&#10;        <meta property="og:description" content="Discover Bakelore's journey, our expert team, and commitment to quality baking in Madhapur, Hyderabad." />&#10;        <meta property="og:image" content="https://bakelore.com/images/bakelore-about.jpg" />&#10;        <meta property="og:url" content="https://bakelore.com/about" />&#10;        <meta property="og:type" content="website" />&#10;      </Helmet>&#10;      <div>&#10;        <AboutBanner/>&#10;        <AboutSection/>&#10;        <OurTeam/>&#10;        <InstagramGrid/>&#10;      </div>&#10;    </>&#10;  )&#10;}&#10;&#10;export default About


import React from "react";
import { Helmet } from "react-helmet-async";

import AboutBanner from "@/components/ui/AboutPage/AboutBanner";
import AboutSection from "@/components/ui/AboutPage/AboutSection";
import OurTeam from "@/components/ui/AboutPage/OurTeam";
import InstagramGrid from "@/components/ui/Homepage/InstagramFeed";

const About = () => {
  return (
    <>
      <Helmet>
        {/* Primary SEO */}
        <title>
          About Bakelore | Best Bakery in Madhapur, Hyderabad for Cakes & Desserts
        </title>

        <meta
          name="description"
          content="Discover Bakelore Bakery in Madhapur, Hyderabad. Learn about our story, expert bakers, premium ingredients, and passion for creating delicious cakes, pastries, and desserts."
        />

        <meta
          name="keywords"
          content="Bakelore bakery Hyderabad, best bakery Madhapur, cakes Hyderabad, birthday cakes Hyderabad, custom cakes Hyderabad, premium bakery Hyderabad"
        />

        <meta name="author" content="Bakelore Bakery" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph (Facebook / WhatsApp) */}
        <meta
          property="og:title"
          content="About Bakelore | Premium Bakery in Hyderabad"
        />

        <meta
          property="og:description"
          content="Explore Bakelore's journey, expert baking team, and handcrafted cakes made with love in Madhapur, Hyderabad."
        />

        <meta
          property="og:image"
          content="https://bakelore.com/images/bakelore-about.jpg"
        />

        <meta property="og:url" content="https://bakelore.com/about" />
        <meta property="og:type" content="website" />

        {/* Twitter SEO */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Bakelore | Hyderabad's Favourite Bakery"
        />
        <meta
          name="twitter:description"
          content="Learn about Bakelore bakery, our story, expert chefs, and handcrafted desserts in Madhapur."
        />
        <meta
          name="twitter:image"
          content="https://bakelore.com/images/bakelore-about.jpg"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://bakelore.com/about" />

        {/* Structured Data (Local Business SEO Boost) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Bakery",
            name: "Bakelore",
            image: "https://bakelore.com/images/bakelore-about.jpg",
            "@id": "https://bakelore.com/",
            url: "https://bakelore.com/",
            telephone: "+91-XXXXXXXXXX",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Madhapur",
              addressLocality: "Hyderabad",
              addressRegion: "Telangana",
              postalCode: "500081",
              addressCountry: "IN",
            },
            sameAs: [
              "https://www.instagram.com/bakelore",
              "https://www.facebook.com/bakelore",
            ],
          })}
        </script>
      </Helmet>

      <div>
        <AboutBanner />
        <AboutSection />
        <OurTeam />
        <InstagramGrid />
      </div>
    </>
  );
};

export default About;